import { Tab } from '../const';

/**
 * @function makeCheckedTabs
 * @param { array } tabs
 * @param { string } id
 * @returns { array }
 */
function makeCheckedTabs(tabs, id) {
	let results = Array.from(tabs);

	const i = results.findIndex((tab) => tab[Tab.Id] === id);

	if (results[i][Tab.Checked] === true) {
		results[i][Tab.Checked] = false;
	} else {
		results[i][Tab.Checked] = true;
	}

	return results;
}

export default makeCheckedTabs;
